import { drawBox, drawLine, drawPoint } from "../draw/draw";
import { INTERSECTION, Brush, Evaluator } from "three-bvh-csg";
import * as BufferGeometryUtils from "three/addons/utils/BufferGeometryUtils.js";
import { BoxGeometry } from "three";
import { getFacesArea } from "@/components/geometry/geometryLoader";
import { computeBoundsTree, MeshBVH, MeshBVHVisualizer } from "three-mesh-bvh";
import { ConvexGeometry } from "three/addons/geometries/ConvexGeometry.js";

//#region Field
const tempVector = new THREE.Vector3();
const tempLine = new THREE.Line3();
const localPlane = new THREE.Plane();

const csgEvaluator = new Evaluator();
let isCsgInitialized = false;

//#endregion

function getSegmentsForPlane(mesh, clippingPlane, limitBox, isStrict) {
  let crossPoints = null;
  try {
    let meshGeometry = mesh.geometry;
    if (!meshGeometry.colliderBvh) {
      let bufferGeometry = toBufferGeometry(meshGeometry);
      let clonedGeometry = bufferGeometry.clone();
      clonedGeometry.applyMatrix4(mesh.matrixWorld);
      for (const key in clonedGeometry.attributes) {
        if (key === "position" || key === "normal") {
          continue;
        }
        clonedGeometry.deleteAttribute(key);
      }
      const colliderBvh = new MeshBVH(clonedGeometry, {
        maxLeaafTris: 20, // 10
        maxDepth: 30, // 40 //5
      });
      meshGeometry.colliderBvh = colliderBvh;
      bufferGeometry.boundsTree = colliderBvh;
      const colliderMesh = new THREE.Mesh(bufferGeometry);
      colliderMesh.renderOrder = 2;
      const inverseMatrix = new THREE.Matrix4();
      inverseMatrix.copy(colliderMesh.matrixWorld).invert();
      meshGeometry.inverseMatrix = inverseMatrix;
    }

    crossPoints = getCrossPoints(
      meshGeometry.colliderBvh,
      meshGeometry.inverseMatrix,
      clippingPlane,
    );

    if (crossPoints.length > 0 && limitBox) {
      limitBox = new THREE.Box3(limitBox.min, limitBox.max);
      let tempPoints = crossPoints.filter((p) => limitBox.containsPoint(p));
      if (tempPoints.length > 1 || isStrict) {
        crossPoints = tempPoints;
      }
    }
  } catch (error) {
    console.log("getCrossGeomFromPlane error", error);
  }
  return crossPoints;
}


function getCrossPointsForPlane(mesh, clippingPlane, limitBox, isStrict) {
  let crossPoints = null;
  try {
    let meshGeometry = mesh.geometry;
    if (!meshGeometry.colliderBvh) {
      let bufferGeometry = toBufferGeometry(meshGeometry);
      let clonedGeometry = bufferGeometry.clone();
      clonedGeometry.applyMatrix4(mesh.matrixWorld);
      for (const key in clonedGeometry.attributes) {
        if (key === "position" || key === "normal") {
          continue;
        }
        clonedGeometry.deleteAttribute(key);
      }
      const colliderBvh = new MeshBVH(clonedGeometry, {
        maxLeaafTris: 20, // 10
        maxDepth: 30, // 40 //5
      });
      meshGeometry.colliderBvh = colliderBvh;
      bufferGeometry.boundsTree = colliderBvh;
      const colliderMesh = new THREE.Mesh(bufferGeometry);
      colliderMesh.renderOrder = 2;
      const inverseMatrix = new THREE.Matrix4();
      inverseMatrix.copy(colliderMesh.matrixWorld).invert();
      meshGeometry.inverseMatrix = inverseMatrix;
    }

    crossPoints = getCrossPoints(
      meshGeometry.colliderBvh,
      meshGeometry.inverseMatrix,
      clippingPlane,
    );

    if (crossPoints.length > 0 && limitBox) {
      limitBox = new THREE.Box3(limitBox.min, limitBox.max);
      let tempPoints = crossPoints.filter((p) => limitBox.containsPoint(p));
      if (tempPoints.length > 1 || isStrict) {
        crossPoints = tempPoints;
      }
    }
  } catch (error) {
    console.log("getCrossGeomFromPlane error", error);
  }
  return crossPoints;
}

function getCrossPoints(colliderBvh, inverseMatrix, clippingPlane) {
  // console.log("renderBVH", app.index, app.pointMatrix);
  // let crossGeom = null;
  const crossPoints = [];
  if (colliderBvh) {
    // const startTime = window.performance.now();
    localPlane.copy(clippingPlane).applyMatrix4(inverseMatrix);
    let i = 0;
    colliderBvh.shapecast({
      intersectsBounds: (box) => {
        //return CONTAINED;
        return localPlane.intersectsBox(box);
      },
      intersectsTriangle: (tri) => {
        i++;
        // let color = 0xff0000;
        // if (i % 2 == 0) color = 0x00ff00;
        // if (i % 3 == 0) color = 0x0000ff;
        // drawLine(tri.a, tri.b, color);
        // drawLine(tri.b, tri.c, color);
        // drawLine(tri.c, tri.a, color);
        // const vectors = [];
        tempLine.start.copy(tri.a);
        tempLine.end.copy(tri.b);
        if (localPlane.intersectLine(tempLine, tempVector)) {
          // vectors.push(tempVector.clone());
          addClonedVector(tempVector, crossPoints);
        }

        tempLine.start.copy(tri.b);
        tempLine.end.copy(tri.c);
        if (localPlane.intersectLine(tempLine, tempVector)) {
          // vectors.push(tempVector.clone());
          addClonedVector(tempVector, crossPoints);
        }

        tempLine.start.copy(tri.c);
        tempLine.end.copy(tri.a);
        if (localPlane.intersectLine(tempLine, tempVector)) {
          // vectors.push(tempVector.clone());
          addClonedVector(tempVector, crossPoints);
        }
        // allPoints.push(...vectors);
        // for (const vector of vectors) {
        // drawPoint(vector, color, false, 0.05);
        // }
        // if (vectors.length >= 2) {
        //   drawLine(vectors[0], vectors[1], color);
        // }
      },
    });
    // const delta = window.performance.now() - startTime;
    // console.log(`slice time: ${parseFloat(delta.toFixed(3))}ms`);
  }

  return crossPoints;
}

function addClonedVector(vector, vectors) {
  if (vector && vector.lengthSq() > 0) {
    let clonedVector = vector.clone();
    vectors.push(clonedVector);
    return clonedVector;
  }
}

function toBufferGeometry(geometry) {
  let bufferGeometry = null;
  if (geometry._bufferGeometry) bufferGeometry = geometry._bufferGeometry;
  else if (geometry.type == "BufferGeometry") {
    bufferGeometry = geometry;
  } else {
    bufferGeometry = new THREE.BufferGeometry().fromGeometry(geometry);
  }
  return bufferGeometry;
}

export { getCrossPointsForPlane, toBufferGeometry };
